/**
 * Feature Manager Tab for DevTools
 * 
 * Integrates the FeatureQuickPanel into DevTools for easy access.
 */

import React from 'react';
import { FeatureQuickPanel } from '../FeatureManager/FeatureQuickPanel';

interface FeatureManagerTabProps {
  domain?: string;
}

const containerStyle: React.CSSProperties = {
  padding: '8px',
};

const headerStyle: React.CSSProperties = {
  fontSize: '14px',
  fontWeight: 600,
  color: '#fff',
  marginBottom: '12px',
  paddingBottom: '8px',
  borderBottom: '1px solid rgba(255,255,255,0.1)',
};

const descriptionStyle: React.CSSProperties = {
  fontSize: '12px',
  color: '#888',
  marginBottom: '16px',
  lineHeight: 1.5,
};

export const FeatureManagerTab: React.FC<FeatureManagerTabProps> = ({ 
  domain = 'devtoolsPlayer' 
}) => {
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>🚦 Feature Manager</div>
      <div style={descriptionStyle}>
        Control which features are visible in this tab. Use whitelist mode to isolate 
        individual features for testing.
      </div>
      <FeatureQuickPanel domain={domain} />
    </div>
  );
};
